import React from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt, faSignInAlt, faUsersCog, faCalendarAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

// import AdminGroupSelect from 'Components/Partials/AdminGroupSelect';

import { asset, filterItemsByAccess } from 'Services/BaseHelpers';
import { getTargetDateString } from 'Services/DateHelpers';
import ChatsApi from 'Services/Api/Networking/Chats';
import User from 'Services/User';
import { currentRegisteredStage } from 'Services/AttendanceHelpers';
import AttendanceActions from 'Components/Partials/AttendanceActions';

class Header extends React.Component {
    /**
     * @var navItems
     * @type {string}
     */
    navItems = [
        // // Pre auth
        // {
        //     to: "/welcome",
        //     title: "Welcome",
        // },
        // {
        //     to: "/information",
        //     title: "Information",
        // },
        {
            to: "/welcome",
            title: "Welcome",
        },
        {
            to: "/speakers",
            title: "Speakers",
        },
        {
            to: "/information",
            title: "Information",
        },
        {
            to: "/on-demand",
            title: "About",
// =======
//             to: "/speakers",
//             title: "Speakers",
// >>>>>>> develop
            // is_logged_in: true
        },
        // {
        //     to: "/networking",
        //     title: "Networking",
        //     is_logged_in: true
        // },
        // {
        //     to: "/attendees",
        //     title: "Attendees",
        //     is_logged_in: true
        // },
        {
            to: "/agenda",
            title: "Agenda",
            // is_logged_in: true
        },
        // {
        //     to: "/main-stage",
        //     title: "Main Stage",
        //    // is_logged_in: true
        // },
        // Register button (special styled item)
        {
            to: "/registration",
            title: "REGISTER",
            is_register: true
        },
        {
            to: "/login",
            icon: faSignInAlt,
            title: "Login",
            is_logged_out: true
        },
        {
            to: "/admin",
            icon: faUsersCog,
            title: "Admin",
            is_admin: true,
            is_logged_in: true
        },
        {
            to: "/logout",
            icon: faSignOutAlt,
            title: "Logout",
            is_logged_in: true
        },
    ];

    state = {
        showOnMobile: false,
        unreadCount: null,
        // Registration status of the logged in delegate, so the header stops prompting
        // someone who already has a place to register for it.
        registeredStage: currentRegisteredStage(),
    }

    componentDidMount() {
        this.fetchUnreadCount();

        User.on('change', this.handleUserChange);
    }

    componentWillUnmount() {
        User.removeListener('change', this.handleUserChange);
    }

    handleUserChange = () => {
        this.setState({ registeredStage: currentRegisteredStage() });
    }

    fetchUnreadCount = async () => {
        const response = await ChatsApi.getNumberUnread();
        if (response.success) {
            this.setState({
                unreadCount: response?.data?.number_unread ?? null
            });
        }
    }

    render() {
        const { showOnMobile } = this.state;
        const { headerImage, titleText, pageVideoHeader = null, location, showRegBanner = true } = this.props;

        return (
            <div className="flex flex-col bg-app-white">
                <div className="flex justify-between p-5 w-full bg-app-white text-app-blue mx-auto flex-nowrap">
                    <Link to="/" className="flex items-center mr-4 lg:mr-8">
                        <img src={ asset ( 'images/logo.png' ) } alt="Logo" className="h-8" />
                    </Link>

                    <div className="hidden lg:flex items-center ml-auto">
                        <div className="flex items-center gap-4">
                            { (() => {
                                const items = filterItemsByAccess(this.navItems) || [];
                                // Exclude the register and login items so we can render register first,
                                // then place the login link immediately after it.
                                const otherItems = items.filter(i => !i.is_register && !i.is_logged_out);
                                return otherItems.map((navItem, i) => this.renderNavItem(navItem, i));
                            })() }

                            { (() => {
                                const items = filterItemsByAccess(this.navItems) || [];
                                const registerItem = items.find(i => i.is_register);
                                if (!registerItem) return null;
                                return (
                                    <>
                                        <NavLink
                                            key="register"
                                            to={ registerItem.to }
                                            className="inline-flex items-center justify-center font-bold px-4 py-2 rounded bg-app-blue text-white lg:w-auto"
                                            onClick={ () => this.setState({ showOnMobile: false }) }
                                            activeClassName="opacity-90"
                                            exact={ true }
                                        >
                                            { this.registerNavLabel(registerItem) }
                                        </NavLink>

                                        {/* Render login immediately after register */}
                                        { (() => {
                                            const loginItem = items.find(i => i.is_logged_out);
                                            if (!loginItem) return null;
                                            return this.renderNavItem(loginItem, 'login_after_register');
                                        })() }
                                    </>
                                );
                            })() }
                        </div>
                    </div>

                    <FontAwesomeIcon
                        icon={ faBars }
                        size="lg"
                        onClick={ () => this.setState ( { showOnMobile: !showOnMobile } ) }
                        className="block lg:hidden cursor-pointer"
                    />
                </div>

                <div className={ `${ showOnMobile ? 'flex flex-col' : 'hidden' } w-full bg-app-white text-app-blue lg:hidden` }>
                    <div className="w-full max-w-6xl mx-auto flex flex-col">
                        <div className="flex flex-col gap-2 w-full">
                            { (() => {
                                const items = filterItemsByAccess(this.navItems) || [];
                                // Exclude register and login so login can be placed after register
                                const otherItems = items.filter(i => !i.is_register && !i.is_logged_out);
                                return otherItems.map((navItem, i) => this.renderNavItem(navItem, i));
                            })() }

                            { (() => {
                                const items = filterItemsByAccess(this.navItems) || [];
                                const registerItem = items.find(i => i.is_register);
                                if (!registerItem) return null;
                                return (
                                    <>
                                        <NavLink
                                            key="register_mobile"
                                            to={ registerItem.to }
                                            className="inline-flex items-center justify-center font-bold px-4 py-3 rounded bg-app-blue text-white w-full"
                                            onClick={ () => this.setState({ showOnMobile: false }) }
                                            activeClassName="opacity-90"
                                            exact={ true }
                                        >
                                            { this.registerNavLabel(registerItem) }
                                        </NavLink>

                                        {/* Render login immediately after register on mobile */}
                                        { (() => {
                                            const loginItem = items.find(i => i.is_logged_out);
                                            if (!loginItem) return null;
                                            return this.renderNavItem(loginItem, 'login_mobile');
                                        })() }
                                    </>
                                );
                            })() }
                        </div>
                    </div>
                </div>

                { pageVideoHeader ? (
                    <div className="w-full">
                        <div className="hidden lg:block w-full">
                            <video
                                src={ asset ( 'images/' + pageVideoHeader ) }
                                className="w-full object-cover"
                                controls={ false }
                                autoPlay
                                muted={ true }
                                controlsList="nodownload nofullscreen noremoteplayback"
                                loop
                                playsInline={ true }
                            />
                        </div>

                        <div className="block lg:hidden w-full">
                            <video
                                src={ asset ( 'images/bupa-banner-mobile.mp4' ) }
                                className="w-full h-auto block object-cover"
                                controls={ false }
                                autoPlay
                                muted={ true }
                                controlsList="nodownload nofullscreen noremoteplayback"
                                loop
                                playsInline={ true }
                            />
                        </div>



                        { /* Don't show the blue register panel when already on the registration page */ }
                        {/* If we're on the dashboard page, render the hero text area above the blue panel */}
                        { location?.pathname === '/welcome' && (
                            <div className="w-full bg-[#e9ecec]">
                                <div className="max-w-6xl mx-auto py-8 md:py-12 px-4">
                                    <h1 className="text-app-blue font-bold text-xl md:text-2xl text-center">Exploring the next steps in connected health</h1>
                                </div>
                                <div className="w-full h-4 bg-app-blue"></div>
                            </div>
                        )}

                        { showRegBanner && (
                            <div className="w-full mx-auto">
                                <div className=" bg-app-blue text-white p-6 md:p-10">
                                    <div className="flex flex-col items-center gap-4">
                                        {/* Date and location: stacked on mobile, inline on lg+ */}
                                        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
                                            <div className="flex items-center gap-1 text-white/90">
                                                <div className="w-8 h-8 rounded-full flex items-center justify-center">
                                                    <FontAwesomeIcon icon={ faCalendarAlt } className="w-4 h-4 text-white/90" />
                                                </div>
                                                <div className="leading-tight text-left">
                                                    <div className="font-semibold text-white">{ getTargetDateString() }</div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-1 text-white/90">
                                                <div className="w-8 h-8 rounded-full flex items-center justify-center">
                                                    <FontAwesomeIcon icon={ faMapMarkerAlt } className="w-4 h-4 text-white/90" />
                                                </div>
                                                <div className="leading-tight text-left">
                                                    <div className="font-semibold text-white">QEII Centre, London</div>
                                                </div>
                                            </div>
                                        </div>

                                        { this.renderRegistrationStatus() }

                                        <AttendanceActions className="bg-white text-app-blue px-12 py-4 rounded-xl font-semibold text-sm md:text-xl mt-2" />
                                    </div>
                                </div>
                            </div>
                        ) }
                    </div>
                ) : (
                    headerImage && (
                        <div className="relative w-full h-auto">
                            <img src={ asset ( headerImage ) } alt="Header" className="w-full h-auto" />
                            { titleText && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <span className="text-white text-2xl md:text-7xl">{ titleText }</span>
                                </div>
                            ) }
                        </div>
                    )
                ) }
            </div>
        );
    }

    /**
     * Line above the banner button telling the delegate where they stand. Nothing is shown
     * until they have registered, so the banner keeps its original look for new visitors.
     */
    renderRegistrationStatus = () => {
        const messages = {
            'confirm-attending': 'Your in-person place is reserved',
            'confirm-waitlist': "You're on the in-person waitlist",
            'confirm-not-attending': 'Your virtual place is reserved',
        };

        const message = messages[this.state.registeredStage];

        if (!message) {
            return null;
        }

        return (
            <div className="font-semibold text-white mt-2">{ message }</div>
        );
    }

    /**
     * A registered delegate is pointed at their own registration rather than invited to
     * make another one.
     */
    registerNavLabel = (registerItem) => (
        this.state.registeredStage ? 'MY REGISTRATION' : registerItem.title
    );

    renderNavItem = ( navItem, key ) => {
        const { unreadCount } = this.state;

        return (
            <div key={ key } className={'relative'}>
                <NavLink
                    className="flex flex-row justify-center items-center gap-2 font-bold w-full lg:w-auto py-3 lg:py-0"
                    activeClassName="border-b-2 border-app-primary"
                    to={ navItem.to }
                    exact={ true }
                    onClick={ () => this.setState({ showOnMobile: false }) }
                >
                    { navItem.icon &&
                        <FontAwesomeIcon icon={ navItem.icon } size="1x" />
                    }

                    { navItem.title }
                </NavLink>
                { unreadCount > 0 &&  navItem.to === '/networking' && (
                    <div className="absolute top-[-0.5rem] right-[-0.5rem] inline-block w-4 h-4 bg-red-600 rounded-full text-xs">{ unreadCount }</div>
                ) }
            </div>
        );
    };
}

export default withRouter ( Header );
